import { transmission, WEB_METHODS } from '../../network/index'

const NICE_API_URL = 'apis/v1/nice'
const RAON_API_URL = 'apis/v1/raon'

const state = {
}

const mutations = {
}

const actions = {
  /**
   * 나이스 본인인증 모듈 URL,key 정보 조회
   * @param commit
   * @param payload
   * @returns {Promise<GET>}
   */
  // eslint-disable-next-line no-unused-vars
  async getNiceEncryptData ({commit}, payload) {
    return transmission(false, WEB_METHODS.GET, NICE_API_URL + '/encryptKey', payload)
  },
  /**
   * 나이스 아이핀인증 모듈 URL,key 정보 조회
   * @param commit
   * @param payload
   * @returns {Promise<GET>}
   */
  // eslint-disable-next-line no-unused-vars
  async getNiceIPINEncryptData ({commit}, payload) {
    return transmission(false, WEB_METHODS.GET, NICE_API_URL + '/ipin/encryptKey', payload)
  },
  /**
   * 나이스 본인인증 성공 처리
   * @param commit
   * @param payload
   * @returns {Promise<GET>}
   */
  // eslint-disable-next-line no-unused-vars
  async identityVerificationSuccess ({commit}, payload) {
    return transmission(false, WEB_METHODS.POST, NICE_API_URL + '/identity-verification/success', payload)
  },
  /**
   * 나이스 아이핀 성공 처리
   * @param commit
   * @param payload
   * @returns {Promise<GET>}
   */
  // eslint-disable-next-line no-unused-vars
  async IPINSuccess ({commit}, payload) {
    return transmission(false, WEB_METHODS.POST, NICE_API_URL + '/ipin/success', payload)
  },
  /**
   * 신용카드 본인인증 서비스 요청을 위해 필요한 파라미터 조회
   * @param commit
   * @param payload
   * @returns {Promise<GET>}
   */
  // eslint-disable-next-line no-unused-vars
  async getRaonCertInfo ({commit}, payload) {
    return transmission(false, WEB_METHODS.GET, RAON_API_URL + '/card/CertInfo', payload)
  },
  /**
   * 신용카드 본인인증 성공 처리
   * @param commit
   * @param payload
   * @returns {Promise<GET>}
   */
  // eslint-disable-next-line no-unused-vars
  async creditCardSuccess ({commit}, payload) {
    return transmission(false, WEB_METHODS.POST, RAON_API_URL + '/credit-card/success', payload)
  }
}

export default { state, mutations, actions }
